import { OrderItem } from './orderitem';

export class Order{
    orderId:string;
    orderitems:Array<OrderItem>;
    orderTotal: number;
    orderDate:Date;
}


// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/common/models/order.ts